import PropTypes from 'prop-types';
import { Autocomplete } from '@mui/material';
import { Input } from '../index';

function ClinicPicker({ clinics, selectedClinic, onSelectClinic, disabled, required, errorText }) {
    return (
        <Autocomplete
            disabled={disabled}
            className="form-field"
            options={clinics}
            renderInput={(props) => (
                <Input {...props} error={errorText} helperText={errorText} label={`Clinics ${required ? '*' : ''}`} />
            )}
            renderOption={(props, option) => (
                <li {...props} key={option.id}>
                    {option.name}
                </li>
            )}
            getOptionLabel={(option) => option?.name || ''}
            value={clinics.find((c) => c.id === selectedClinic) || null}
            onChange={(event, newValue) => {
                onSelectClinic(newValue?.id || '');
            }}
        />
    );
}

ClinicPicker.propTypes = {
    clinics: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
    })).isRequired,
    onSelectClinic: PropTypes.func,
    selectedClinic: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    errorText: PropTypes.string,
};

ClinicPicker.defaultProps = {
    onSelectClinic: () => {},
    selectedClinic: '',
    disabled: false,
    required: false,
    errorText: '',
};

export default ClinicPicker;
